export enum TopMenuItem {
  Tool = 'Review Tool',
  Metadata = 'Metadata',
  Settings = 'Settings',
  Logout = 'Logout',
  Login = 'Login',
}

export const loggedTopMenuItems = [TopMenuItem.Tool, TopMenuItem.Metadata, TopMenuItem.Settings, TopMenuItem.Logout]

export const notLoggedTopMenuItems = [TopMenuItem.Login]
